const StaffOverViewPage = () => {
    return(
        <></>
    );
}

export default StaffOverViewPage;